import FileDownload from "js-file-download";
import {
  getAPICompanyData,
  exportCompanyData,
  getReportByRegion,
  getLoginTimeReportByRegion,
  getRegions,
  getFirstDateData,
  getCompaniesByRegion,
  exportOfficeData,
  exportLoginTimeDetailsData,
  getCompanyInfo
} from "@/api/ppanalytic.api";

const fn = {
  SET_COMPANY: "SET_COMPANY",
  SET_OFFICE: "SET_OFFICE",
  SET_LOGIN_TIME: "SET_LOGIN_TIME",
  RESET_COMPANY: "RESET_COMPANY",
  RESET_OFFICE: "RESET_OFFICE",
  RESET_LOGIN_TIME: "RESET_LOGIN_TIME",
  SET_REGIONS: "SET_REGIONS",
  SET_COMPANIES: "SET_COMPANIES",
  SET_FILTERS: "SET_FILTERS",
  SET_FIRST_DATE: "SET_FIRST_DATE",
  RESET: "RESET",
  SET_LOADING: "SET_LOADING"
};

const initialState = () => ({
  clientData: {}, // if have data it will store in key name => clients
  officeData: {},
  loginTimeDetailsData: {},
  filters:{},
  regions: ["All Regions"],
  companies: [],
  firstDate: "",
  loading: false,
});

const state = initialState();

const getters = {
  getClientData: state => state.clientData,
  getOfficeData: state => state.officeData,
  getLoginTimeDetailsData: state => state.loginTimeDetailsData,
  getRegionData: state => state.regions,
  getFirstDate: state => state.firstDate,
  getCompaniesData: state => state.companies,
  getLoading: state => state.loading
};

// actions
const actions = {
  reset({ commit }) {
    commit(fn.RESET);
  },
  async getCompanyData({ commit }, payload) {
    try {
      commit(fn.SET_LOADING, true);
      commit(fn.SET_FILTERS, payload);
      let resp = await getCompanyInfo(payload);
      if (resp.data) {
        if(payload.version == 'v2') {
          commit(fn.SET_COMPANY, { ...resp.data});
          commit(fn.SET_LOADING, false);
        }
        
        if(payload.version == 'v1') {
          const { start_date, end_date, datetime_period } = resp.data;
          let respCompanyData = await getAPICompanyData({
            start_date: start_date,
            end_date: end_date,
            datetime_period: datetime_period
          });
  
          if (respCompanyData.data) {
            commit(fn.SET_COMPANY, { ...resp.data, ...respCompanyData.data });
            commit(fn.SET_LOADING, false);
          }
        }
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getOfficeData({ commit }, payload) {
    try {
      commit(fn.SET_LOADING, true);
      commit(fn.SET_FILTERS, payload);
      let resp = await getReportByRegion(payload);
      if (resp.data) {
        commit(fn.SET_OFFICE, resp.data);
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getLoginTimeDetailsData({ commit }, payload) {
    try {
      commit(fn.SET_LOADING, true);
      commit(fn.SET_FILTERS, payload);
      let resp = await getLoginTimeReportByRegion(payload);
      if (resp.data) {
        commit(fn.SET_LOGIN_TIME, resp.data);
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getRegionData({ commit }) {
    try {
      commit(fn.SET_LOADING, true);
      let resp = await getRegions();
      if (resp) {
        commit(fn.SET_REGIONS, resp.data.regions);
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getFirstDate({ commit }) {
    try {
      commit(fn.SET_LOADING, true);
      let resp = await getFirstDateData();
      if (resp) {
        commit(fn.SET_FIRST_DATE, resp.data);
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async getCompaniesDataByRegion({ commit }, payload) {
    try {
      commit(fn.SET_LOADING, true);
      let resp = await getCompaniesByRegion(payload);
      if (resp) {
        commit(fn.SET_COMPANIES, resp.data.companies);
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async exportCompanyData({ commit, state }) {
    try {
      commit(fn.SET_LOADING, true);
      let resp;
      if(state.filters.version == 'v1') {
        resp = await exportCompanyData(state.clientData);
      } else {
        resp = await exportCompanyData(state.filters);
      }
      if (resp.data) {
        FileDownload(resp.data, "general_statistics.xlsx");
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async exportOfficeData({ commit, state }) {
    try {
      commit(fn.SET_LOADING, true);
      let resp;
      if(state.filters.version == 'v1') {
        resp = await exportOfficeData(state.officeData);
      } else {
        resp = await exportOfficeData(state.filters);
      }
      if (resp.data) {
        FileDownload(resp.data, "office_statistics.xlsx");
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async exportLoginTimeDetailsData({ commit, state }) {
    try {
      commit(fn.SET_LOADING, true);
      let resp = await exportLoginTimeDetailsData(state.filters);
      if (resp.data) {
        FileDownload(resp.data, "login_time_details.xlsx");
        commit(fn.SET_LOADING, false);
      }
    } catch (err) {
      commit(fn.SET_LOADING, false);
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  resetCompany({ commit }) {
    commit(fn.RESET_COMPANY);
  }
};

// mutations
const mutations = {
  [fn.SET_COMPANY](state, payload) {
    state.clientData = payload;
  },
  [fn.SET_OFFICE](state, payload) {
    state.officeData = payload;
  },
  [fn.SET_LOGIN_TIME](state, payload) {
    state.loginTimeDetailsData = payload;
  },
  [fn.SET_REGIONS](state, payload) {
    state.regions = [...state.regions, ...payload];
  },
  [fn.SET_COMPANIES](state, payload) {
    state.companies = [...payload];
  },
  [fn.RESET_COMPANY](state) {
    state.clientData = {};
  },
  [fn.RESET_OFFICE](state) {
    state.officeData = {};
  },
  [fn.RESET_LOGIN_TIME](state) {
    state.loginTimeDetailsData = {};
  },
  [fn.SET_FILTERS](state, payload) {
    state.filters = payload;
  },
  [fn.SET_FIRST_DATE](state, payload) {
    state.firstDate = payload;
  },
  [fn.RESET](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  [fn.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
